// extracted by mini-css-extract-plugin
export var button = "styles-module--button--8d7d5";
export var card = "styles-module--card--920dd";
export var header = "styles-module--header--94ce4";
export var spacer = "styles-module--spacer--e992a";
export var toggle = "styles-module--toggle--d274a";
export var wrapper = "styles-module--wrapper--227e4";